module.exports = __webpack_public_path__ + "static/img/camo_chair_max.140a4d75.png";